const initial_state = {
  alert: null,
  isOpen: false,
  severity: 'error',
  title: 'Erreur',
  role: 'alert'
};

export const alertReducer  = (state = initial_state, action) => {
  const { alert, severity, title, role } = action;
  if (alert) {
    return {
      content: alert,
      isOpen: true,
      severity: severity,
      title: title,
      role: role
    };
  } else if (action.type === 'HIDE_ALERT') {
    return {
      content: null,
      isOpen: false
    };
  }
  return state; 
};